// Phone / WhatsApp numbers, sourced from env. Empty/missing → hidden, not rendered.

export function getPhoneNumber(): string | null {
    const value = process.env.NEXT_PUBLIC_PHONE_NUMBER?.trim();
    return value ? value : null;
}

export function getWhatsappNumber(): string | null {
    const value = process.env.NEXT_PUBLIC_WHATSAPP_NUMBER?.trim();
    return value ? value : null;
}

export function toTelHref(displayNumber: string): string {
    return `tel:${displayNumber.replace(/[^\d+]/g, '')}`;
}

export function toWhatsappHref(displayNumber: string): string {
    return `https://wa.me/${displayNumber.replace(/\D/g, '')}`;
}

const FARSI_DIGITS = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];

export function toFarsiDigits(value: string): string {
    return value.replace(/[0-9]/g, (d) => FARSI_DIGITS[Number(d)]);
}

